/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import $ from 'jquery';

/* eslint-disable import/no-unresolved, import/default */

import logoSvg from '../../svg/logo_title_white.svg';

/* eslint-enable import/no-unresolved, import/default */

/* eslint-disable angular/angularelement */

/*@ngInject*/
export default function HomeController(types, loginService, userService, Fullscreen, $scope, $element, $rootScope, $document, $state,
                                       $window, $log, $mdMedia, $animate, $timeout) {

    var siteSideNav;
    var vm = this;

    vm.$onInit = function () {
        siteSideNav = $('.tk-site-sidenav', $element);

        vm.Fullscreen = Fullscreen;
        vm.logoSvg = logoSvg;

        if (angular.isUndefined($rootScope.searchConfig)) {
            $rootScope.searchConfig = {
                searchEnabled: false,
                showSearch: false,
                searchText: ""
            };
        }

        vm.isShowSidenav = false;
        vm.isLockSidenav = false;

        vm.displaySearchMode = displaySearchMode;
        vm.openSidenav = openSidenav;
        vm.goBack = goBack;
        vm.searchTextUpdated = searchTextUpdated;
        vm.sidenavClicked = sidenavClicked;
        vm.toggleFullscreen = toggleFullscreen;
        vm.openSearch = openSearch;
        vm.closeSearch = closeSearch;

        vm.isGtSm = $mdMedia('gt-sm');
        if (vm.isGtSm) {
            vm.isLockSidenav = true;
            $animate.enabled(siteSideNav, false);
        }
    };

    $scope.$on('$stateChangeSuccess', function (evt, to, toParams, from) {
        if (angular.isDefined(to.data.searchEnabled)) {
            $scope.searchConfig.searchEnabled = to.data.searchEnabled;
            if ($scope.searchConfig.searchEnabled === false || to.name !== from.name) {
                $scope.searchConfig.showSearch = false;
                $scope.searchConfig.searchText = "";
            }
        } else {
            $scope.searchConfig.searchEnabled = false;
            $scope.searchConfig.showSearch = false;
            $scope.searchConfig.searchText = "";
        }
    });

    $scope.$watch(function () {
        return $mdMedia('gt-sm');
    }, function (isGtSm) {
        vm.isGtSm = isGtSm;
        vm.isLockSidenav = isGtSm;
        vm.isShowSidenav = isGtSm;
        if (!isGtSm) {
            $timeout(function () {
                $animate.enabled(siteSideNav, true);
            }, 0, false);
        } else {
            $animate.enabled(siteSideNav, false);
        }
    });

    function displaySearchMode() {
        return $scope.searchConfig.searchEnabled &&
            $scope.searchConfig.showSearch;
    }

    function toggleFullscreen() {
        if (Fullscreen.isEnabled()) {
            Fullscreen.cancel();
        } else {
            Fullscreen.all();
        }
    }

    function openSearch() {
        if ($scope.searchConfig.searchEnabled) {
            $scope.searchConfig.showSearch = true;
            $timeout(() => {
                angular.element('#tb-search-text-input', $element).focus();
            });
        }
    }

    function closeSearch() {
        if ($scope.searchConfig.searchEnabled) {
            $scope.searchConfig.showSearch = false;
            if ($scope.searchConfig.searchText.length) {
                $scope.searchConfig.searchText = '';
                searchTextUpdated();
            }
        }
    }

    function searchTextUpdated() {
        $scope.$broadcast('searchTextUpdated');
    }

    function openSidenav() {
        vm.isShowSidenav = true;
    }

    function goBack() {
        $window.history.back();
    }

    function closeSidenav() {
        vm.isShowSidenav = false;
    }

    function sidenavClicked() {
        if (!vm.isLockSidenav) {
            closeSidenav();
        }
    }

}

/* eslint-enable angular/angularelement */


// WEBPACK FOOTER //
// ./src/app/layout/home.controller.js